export default __webpack_public_path__ + "static/media/dumbbells.977a62bf.svg";